import FileGenerator from '@/components/entities/patient/views/FileGenerator';

const ScanChartFileGenerator = FileGenerator('scanChart', 'ScanChart');

export default ScanChartFileGenerator;
